import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateSystemUiModuleComponent(
    $id: String!
    $data: updateSystemUiModuleComponentInput!
  ) {
    updateSystemUiModuleComponent(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateSystemUiModuleComponentRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateSystemUiModuleComponentInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_ui_module_component/update_system_ui_module_component',
  async (
  params: {id: String;data: TYPES.UpdateSystemUiModuleComponentInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateSystemUiModuleComponent;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateSystemUiModuleComponentSlice = createSlice({
  name: 'update_system_ui_module_component',
  initialState: initialState,
  reducers: {
    updateSystemUiModuleComponentClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateSystemUiModuleComponentRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      updateSystemUiModuleComponentRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      updateSystemUiModuleComponentRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { updateSystemUiModuleComponentClear } =
updateSystemUiModuleComponentSlice.actions;

export const updateSystemUiModuleComponent = createSelector(
  (state: RootState) =>
  state.systemUiModuleComponent.updateSystemUiModuleComponent.result,
  (state: RootState) =>
  state.systemUiModuleComponent.updateSystemUiModuleComponent.error,
  (state: RootState) =>
  state.systemUiModuleComponent.updateSystemUiModuleComponent.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateSystemUiModuleComponentSlice.reducer;